import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function FloatingMessageButton() {
  return <motion.a href="sms:6192492966" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 15
  }} className="fixed bottom-24 md:bottom-8 right-6 z-50 bg-accent hover:bg-accent/90 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg shadow-accent/30 transition-colors group" aria-label="Enviar mensaje directo" data-id="element-69">
      <MessageCircle size={28} className="group-hover:scale-110 transition-transform" data-id="element-70" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse" data-id="element-71" />
    </motion.a>;
}